import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance173r3f2itu405 as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.d26_1 = key;
        this.e26_1 = value;
      }
      m3() {
        return this.d26_1;
      }
      n3() {
        return this.e26_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.d26_1) + ', value=' + toString(this.e26_1) + ')';
      }
      hashCode() {
        var result = this.d26_1 == null ? 0 : hashCode(this.d26_1);
        result = imul(result, 31) + (this.e26_1 == null ? 0 : hashCode(this.e26_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.d26_1, other.d26_1))
          return false;
        if (!equals(this.e26_1, other.e26_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.h26_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.z1m('key', keySerializer.g1m());
          $this$buildSerialDescriptor.z1m('value', valueSerializer.g1m());
          return Unit_instance;
        });
      }
      g1m() {
        return this.h26_1;
      }
      i26(_this__u8e3s4) {
        return _this__u8e3s4.m3();
      }
      j26(_this__u8e3s4) {
        return this.i26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      k26(_this__u8e3s4) {
        return _this__u8e3s4.n3();
      }
      l26(_this__u8e3s4) {
        return this.k26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m26(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.s26_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.z1m('first', keySerializer.g1m());
          $this$buildClassSerialDescriptor.z1m('second', valueSerializer.g1m());
          return Unit_instance;
        });
      }
      g1m() {
        return this.s26_1;
      }
      t26(_this__u8e3s4) {
        return _this__u8e3s4.xe_1;
      }
      j26(_this__u8e3s4) {
        return this.t26(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      u26(_this__u8e3s4) {
        return _this__u8e3s4.ye_1;
      }
      l26(_this__u8e3s4) {
        return this.u26(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      m26(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.k1r($this.y26_1, 0, $this.v26_1);
  var b = composite.k1r($this.y26_1, 1, $this.w26_1);
  var c = composite.k1r($this.y26_1, 2, $this.x26_1);
  composite.y1q($this.y26_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.o1r($this.y26_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.k1r($this.y26_1, 0, $this.v26_1);
        break;
      case 1:
        b = composite.k1r($this.y26_1, 1, $this.w26_1);
        break;
      case 2:
        c = composite.k1r($this.y26_1, 2, $this.x26_1);
        break;
      default:
        throw SerializationException().b1o('Unexpected index ' + index);
    }
  }
  composite.y1q($this.y26_1);
  if (a === get_NULL())
    throw SerializationException().b1o("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().b1o("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().b1o("Element 'third' is missing");
  return new (Triple())(a, b, c);
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.v26_1 = aSerializer;
        this.w26_1 = bSerializer;
        this.x26_1 = cSerializer;
        var tmp = this;
        tmp.y26_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.z1m('first', this.v26_1.g1m());
          $this$buildClassSerialDescriptor.z1m('second', this.w26_1.g1m());
          $this$buildClassSerialDescriptor.z1m('third', this.x26_1.g1m());
          return Unit_instance;
        });
      }
      g1m() {
        return this.y26_1;
      }
      z26(encoder, value) {
        var structuredEncoder = encoder.x1q(this.y26_1);
        structuredEncoder.p1s(this.y26_1, 0, this.v26_1, value.lt_1);
        structuredEncoder.p1s(this.y26_1, 1, this.w26_1, value.mt_1);
        structuredEncoder.p1s(this.y26_1, 2, this.x26_1, value.nt_1);
        structuredEncoder.y1q(this.y26_1);
      }
      h1m(encoder, value) {
        return this.z26(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      i1m(decoder) {
        var composite = decoder.x1q(this.y26_1);
        if (composite.n1r()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.n26_1 = keySerializer;
        this.o26_1 = valueSerializer;
      }
      p26(encoder, value) {
        var structuredEncoder = encoder.x1q(this.g1m());
        structuredEncoder.p1s(this.g1m(), 0, this.n26_1, this.j26(value));
        structuredEncoder.p1s(this.g1m(), 1, this.o26_1, this.l26(value));
        structuredEncoder.y1q(this.g1m());
      }
      h1m(encoder, value) {
        return this.p26(encoder, value);
      }
      i1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.g1m();
        var composite = decoder.x1q(descriptor);
        var tmp$ret$1;
        $l$block: {
          if (composite.n1r()) {
            var key = composite.k1r(this.g1m(), 0, this.n26_1);
            var value = composite.k1r(this.g1m(), 1, this.o26_1);
            tmp$ret$1 = this.m26(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.o1r(this.g1m());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.k1r(this.g1m(), 0, this.n26_1);
                break;
              case 1:
                value_0 = composite.k1r(this.g1m(), 1, this.o26_1);
                break;
              default:
                throw SerializationException().b1o('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().b1o("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().b1o("Element 'value' is missing");
          tmp$ret$1 = this.m26(key_0, value_0);
        }
        var result = tmp$ret$1;
        composite.y1q(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
